// extracted by mini-css-extract-plugin
module.exports = {"td":"HoveredPointTooltip_td_nvvXW","firstTd":"HoveredPointTooltip_firstTd_30NG_","th":"HoveredPointTooltip_th_3zKtt"};